module.exports = __webpack_public_path__ + "img/796D6B_DED3CB_C6BAB1_ADA09B-256px.414c7a45.png";